import app from 'flarum/common/app';
import Tooltip from 'flarum/common/components/Tooltip';
import icon from 'flarum/common/helpers/icon';
import Widget, { WidgetAttrs } from 'flarum/extensions/fof-forum-widgets-core/common/components/Widget';
import extractText from 'flarum/common/utils/extractText';

export default class ForumStatsWidgetWidget extends Widget<WidgetAttrs> {
  className(): string {
    return 'FoF-ForumStatsWidget';
  }

  icon(): string {
    return 'fas fa-chart-pie';
  }

  title(): string {
    return extractText(app.translator.trans('fof-forum-stats-widget.forum.widget.title'));
  }

  content() {
    const stats = app.forum.attribute<Record<string, { label: string; icon: string; prettyValue: string }>>('fof-forum-stats-widget.stats');

    return (
      <div className="FoF-ForumStatsWidget-grid">
        {Object.keys(stats).map((stat) => (
          <Tooltip text={stats[stat].label}>
            <span className="FoF-ForumStatsWidget-grid-item">
              <span className="FoF-ForumStatsWidget-grid-item-icon">{icon(stats[stat].icon)}</span>
              <span className="FoF-ForumStatsWidget-grid-item-value">{stats[stat].prettyValue}</span>
            </span>
          </Tooltip>
        ))}
      </div>
    );
  }
}
